// src/components/upload/upload.utils.ts
function parseFile({
  file,
  maxFileSize
}) {
  const maxSizeBytes = maxFileSize * 1024 * 1024;
  let error;
  const isOverMaxFileSize = file.size > maxSizeBytes;
  if (isOverMaxFileSize) {
    error = `File exceeds file size limit of ${maxFileSize}MB`;
  }
  return {
    name: file.name,
    url: URL.createObjectURL(file),
    file,
    pending: error ? false : true,
    error
  };
}
export {
  parseFile
};
